import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { SettlementTransaction } from '@/lib/types/settlement';

export function usePendingTransactions() {
  const [transactions, setTransactions] = useState<SettlementTransaction[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, 'settlement_transactions'),
      where('status', '==', 'pending')
    );
    const unsub = onSnapshot(q, (snap) => {
      setTransactions(snap.docs.map(d => ({ id: d.id, ...d.data() }) as SettlementTransaction));
      setLoading(false);
    }, (err) => {
      console.error('Failed to load pending transactions:', err);
      setLoading(false);
    });
    return unsub;
  }, []);

  return { transactions, loading };
}
